


/**
 * 消息中心 接口路径
 */
export const  messageCenterRequestUrl={
  getMessageCount:`/community-api/community/messages/count`,
  getMessageList: `/community-api/community/messages/list`,
  getMessageDetail: `/community-api/community/messages/detail`,
  readMessage: `/community-api/community/messages/read`,
  deleteMessage: `/community-api/community/messages/delete`,
  getNDADownloadUrl:`/community-api/community/fadada/sign/getDownloadUrl`,
  get2KbDownloadUrl:`/community-api/community/messages/getUrl`,
  getFileDownloadUrl:`/community-api/community/messages/download/file/url`,
}


/**
 * 费用中心 接口路径
 */
export const expenseRequestUrls={
  getAccountOverview:'/buyer/community/costCenter/get/overview',
  getAccountOverviewWallet:'/buyer/community/costCenter/get/wallet',
  getAccountOverviewInvoiceMoney:'/buyer/community/costCenter/get/invoiceMoney',
  getAccountOrderList:'/buyer/community/costCenter/order/list',
  createRechargeOrder:'/buyer/trade/recharge',
  sendremitAccountName:'/buyer/community/remit/save',
  paymentForOrder:'/buyer/payment/cashier/pay',
  getInoviceRecords:'/buyer/community/invoice/record',
  calcuateOrderAmount:'/buyer/community/costCenter/get/orderMoney',
  submitInvoice:'/buyer/community/invoice/save',
  checkWalletForOrder:'/buyer/community/costCenter/check/walletForOrder',
  getPaymentResult:'/buyer/payment/cashier/result'
}


export const questionRequestUrls={
  uploadFile:'/community-api/community/upload/file',
  cancelThumbsUp:'/community-api/community/questAndAnswer/cancelThumbsUp',
  addThumbsUp:'/community-api/community/questAndAnswer/addThumbsUp',
  deleteFile:'/community-api/community/file/delete',
  saveQuestion:'/community-api/community/questAndAnswer/save',
  getQuestionUserList:'/community-api/community/personalCenter/user/list',
  getNoticeList:'/community-api/community/notice/list',
  getFAQList:'/community-api/community/faq/list',
  getNoticeDetail:'/community-api/community/notice/detail',
  getFAQDetail:'/community-api/community/faq/detail', 
  getFAQTypeList:'/community-api/community/faq/type/list',
  getNoticeTypeList:'/community-api/community/notice/type/list',
  addNoticeViewCount:'/community-api/community/notice/addViewCount',
  addFaqViewCount:'/community-api/community/faq/addViewCount',
  addNoticeThumbsUp:'/community-api/community/notice/addThumbsUp',
  cancelNoticeThumbsUp:'/community-api/community/notice/cancelThumbsUp',
  addFaqThumbsUp:'/community-api/community/faq/addThumbsUp',
  cancelFaqThumbsUp:'/community-api/community/faq/cancelThumbsUp',
  addQuestionCollect: '/community-api/community/questAndAnswer/addFavorite',
  addNoticeCollect: '/community-api/community/notice/addFavorite',
  addFaqCollect: '/community-api/community/faq/addFavorite',
  questionCommentRecord: '/community-api/community/questAndAnswer/comment/list',
  faqCommentRecord: '/community-api/community/faq/comment/list',
  pubQuestionComment: '/community-api/community/questAndAnswer/comment/save',
  pubFaqComment: '/community-api/community/faq/comment/save',
  deleteQuestionComment: '/community-api/community/questAndAnswer/comment',
  deleteFaqComment: '/community-api/community/faq/comment',
  QuestionUserIsFavorite: '/community-api/community/questAndAnswer/currentUserIsFavorite',
  FaqUserIsFavorite: '/community-api/community/faq/currentUserIsFavorite',
  NoticeUserIsFavorite: '/community-api/community/notice/currentUserIsFavorite',
  QuestionUserIsThumbsUp: '/community-api/community/questAndAnswer/currentUserIsThumbsUp',
  FaqUserIsThumbsUp: '/community-api/community/faq/currentUserIsThumbsUp',
  NoticeUserIsThumbsUp: '/community-api/community/notice/currentUserIsThumbsUp',
}


export const faeRequestUrls={
  submitFAEOrder:'/community-api/community/ticket/add',
  getFAEOrderList:'/community-api/community/ticket/list',
  getFAEOrderStatusList:'/community-api/community/ticket/all/status',
  getFAEOrderDetail:'/community-api/community/ticket/detail',
  getFAEProjectDetail:'/community-api/community/faeProject/getCurrentUserProject',
  uploadFile:'/community-api/community/upload/file/attachment',
  updateFAEOrder:'/community-api/community/ticket/update',
  closeFAEOrder:'/community-api/community/ticket/accept',
  addComment:'/community-api/community/ticket/supplement',
  getPermission:'/v2/api/system/user/detail'
}

//资源下载
export const resourceRequestUrls={
  getBannerList:'/community-api/community/banner/list',
  getFreeDownloadCategory:'/community-api/community/resource/category/allChildren/contain/resource',
  getFreeDownloadDetail:'/community-api/community/resource/detail',
  getResourceDownloadUrl:'/community-api/community/resource/getResourceDownloadUrl',
  getResourceGuideDownloadUrl:'/community-api/community/resource/getGuideDownloadUrl',
  getBatchResourceDownloadUrl:"/community-api/community/resource/getBatchResourceDownloadUrl",
  getDownloadUserList:"/community-api/community/resource/getUserDownload",
  getAgreementList:"/community-api/community/resource/getUserSignAgreement"
}

const noNeedLoginUrls=[
  `/community-api/community/messages/count`,
  '/v2/api/system/user/detail',

]



export const activityRequestUrls={
  submitActivitySignup:'/community-api/community/survey/save',
  getActivityDetail:'/community-api/community/survey/getByCode',
  checkSignup:'/community-api/community/survey/isUserAlreadyDo',
  getActivityRecords:'/community-api/community/personalCenter/getUserSurveyAndLottery'
}


export const checkLoginRequestUrls=[...Object.values(expenseRequestUrls),
  ...Object.values(messageCenterRequestUrl),
  ...Object.values(questionRequestUrls),
  ...Object.values(activityRequestUrls),
  ...Object.values(faeRequestUrls),
  ...Object.values(resourceRequestUrls)
].filter(item=>!noNeedLoginUrls.includes(item))